import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_RETURN_SHIPPING, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemRefundReturnShippingMaybe = props => {
  const { lineItems, intl } = props;

  const refund = lineItems.find(item => item.code === LINE_ITEM_RETURN_SHIPPING && item.reversal);

  return refund ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.refundReturnShipping" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, refund.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemRefundReturnShippingMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemRefundReturnShippingMaybe;
